import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import { ChangePaymentResultAction } from './change-payment-result.action';
import TokenRedirectService from '../../common/services/token-redirect.service';
import MobileService from '../../common/services/mobile.service';

/* @ngInject */
export default class ChangePaymentResultController implements ActionHandler {
  private dialogElement;
  protected paymentMethodId;
  protected cardId;
  protected updateSubscription;
  protected isMobile:boolean = false; 

  constructor(
    protected $element,
    private $window,
    protected actionDispatcher: ActionDispatcherService,
    private tokenRedirectService: TokenRedirectService,
    protected mobileService: MobileService
  ) {}

  public $postLink() {
    this.dialogElement = this.$element.find('#change-payment-result').remodal();
    this.actionDispatcher.register(this);
  }
  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof ChangePaymentResultAction) {
      this.paymentMethodId = action.paymentMethodId;
      this.updateSubscription = action.updateSubscription;
      this.cardId = action.cardId;
      console.log('PaymentMethodId', '=>', this.paymentMethodId);
      console.log('updateSubscription', '=>', this.updateSubscription);
      this.openDialog();
    }
  }

  protected onApprove() {
    this.close();
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.dialogElement.open();
    if(this.mobileService.isMobile()){
      this.isMobile = true;
    }
  }

  public onCancel() {
    this.close();
  }

  public close() {
    this.dialogElement.close();
    this.$window.location.href = "/?buySuccess=1"
    this.$window.scrollTo(0,0);
  }

  protected onListen() {
    this.tokenRedirectService.openPlayer();
  }

  protected startListen(){
    this.$window.open('https://fizy.in/Ps93n', '_blank');
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/change-payment-result-dialog/change-payment-result.controller.ts